/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App
 */
// Plugins
import { registerPlugins } from "@/plugins";

// Components
import App from "./App.vue";
import { markTestTitle } from "@/utils/testSite.js";

// Vue Router
import router from "./router";

// Composables
import { createApp } from "vue";

// Styles
import "vuetify/styles";

const app = createApp(App);

// Vue router
app.use(router);

registerPlugins(app);

markTestTitle(); // "[TEST] …" in the tab on a test site
app.mount("#app");


// Styles
// import "unfonts.css";

// ============================================================================
// 1. HELPER FUNCTIONS
// ============================================================================

// function parseExpiry(expiresIn) {
//   if (!expiresIn) return 7 * 24 * 60 * 60 * 1000;
//   const unit = expiresIn.slice(-1);
//   const value = parseInt(expiresIn.slice(0, -1)) || 7;

//   switch (unit) {
//     case "d":
//       return value * 24 * 60 * 60 * 1000;
//     case "h":
//       return value * 60 * 60 * 1000;
//     case "m":
//       return value * 60 * 1000;
//     case "s":
//       return value * 1000;
//     default:
//       return 7 * 24 * 60 * 60 * 1000;
//   }
// }

// /**
//  * Check if we should prevent Vue from mounting
//  * Returns true if Vue should NOT mount
//  */
// const shouldPreventVueMount = () => {
//   // Check if pre-mount script set this flag
//   if (window.__PREVENT_VUE_MOUNT__) {
//     console.log("⛔ Vue mount prevented by pre-mount script");
//     return true;
//   }

//   // Check current state
//   const userStr = localStorage.getItem("user");
//   if (!userStr) {
//     return false; // No user data, let Vue handle it
//   }

//   try {
//     const user = JSON.parse(userStr);
//     const allowedApps = user.allowed_apps ? JSON.parse(user.allowed_apps) : [];
//     const currentPath = window.location.pathname;

//     // Define sales routes
//     const salesRoutes = ["/", "/home", "/sales-form", "/admin"];
//     const isSalesRoute = salesRoutes.some((route) => currentPath.startsWith(route));

//     // If user has no access and is on a sales route
//     if (allowedApps.length === 0 && isSalesRoute) {
//       console.log("⛔ User has no app access on sales route, preventing Vue mount");

//       // Update URL
//       const noAccessUrl = "/no-access";
//       if (currentPath !== noAccessUrl) {
//         window.history.replaceState({}, "", noAccessUrl);
//         setTimeout(() => {
//           window.location.href = noAccessUrl;
//         }, 10);
//       }

//       return true;
//     }

//     return false;
//   } catch (error) {
//     console.error("Error checking mount prevention:", error);
//     return false;
//   }
// };

// /**
//  * Process auth token from URL
//  */
// const processAuthTokenFromUrl = () => {
//   const hash = window.location.hash.slice(1);
//   const query = window.location.search.slice(1);

//   let token, role, email, expiresIn, expiresInMs;

//   // Try hash
//   if (hash) {
//     try {
//       const params = new URLSearchParams(hash);
//       token = params.get("authToken");
//       role = params.get("role");
//       email = params.get("email");
//       expiresIn = params.get("expiresIn");
//       expiresInMs = params.get("expiresInMs");
//     } catch (error) {
//       console.error("Error parsing hash:", error);
//     }
//   }

//   // Try query
//   if (!token && query) {
//     try {
//       const params = new URLSearchParams(query);
//       token = params.get("authToken");
//       role = params.get("role");
//       email = params.get("email");
//       expiresIn = params.get("expiresIn");
//       expiresInMs = params.get("expiresInMs");
//     } catch (error) {
//       console.error("Error parsing query:", error);
//     }
//   }

//   if (token) {
//     // Store auth data
//     localStorage.setItem("authToken", token);
//     localStorage.setItem("userRole", role || "user");

//     // Set allowed apps - IMPORTANT: This should come from your auth server!
//     const allowedApps = role === "admin" ? ["sales", "reviews"] : ["sales"];

//     const userData = {
//       email: email || "",
//       role: role || "user",
//       allowed_apps: JSON.stringify(allowedApps),
//     };

//     localStorage.setItem("user", JSON.stringify(userData));

//     // Calculate expiry
//     let expiryMs;
//     if (expiresInMs) {
//       expiryMs = parseInt(expiresInMs);
//     } else {
//       expiryMs = parseExpiry(expiresIn || "7d");
//     }

//     const expiry = new Date(Date.now() + expiryMs).toISOString();
//     localStorage.setItem("tokenExpiry", expiry);

//     // Clean URL
//     const cleanUrl = window.location.origin + window.location.pathname;
//     window.history.replaceState({}, document.title, cleanUrl);

//     console.log("✅ Auth token processed");

//     return true;
//   }

//   return false;
// };

// // ============================================================================
// // 2. MAIN EXECUTION
// // ============================================================================

// console.log("🚀 Starting main.js execution");

// // Step 1: Process auth token from URL if present
// processAuthTokenFromUrl();

// // Step 2: Check if we should prevent Vue from mounting
// if (shouldPreventVueMount()) {
//   console.log("⛔ NOT mounting Vue app - user lacks permissions");

//   // Hide the pre-load screen since we're not loading Vue
//   const preLoad = document.getElementById("pre-load");
//   if (preLoad) {
//     preLoad.innerHTML = `
//       <div class="pre-load-content">
//         <div style="font-size: 48px; margin-bottom: 20px;">🔒</div>
//         <h2>Access Restricted</h2>
//         <p>You don't have permission to access this application.</p>
//         <div style="margin-top: 20px;">
//           <button onclick="window.location.href='/no-access'" 
//                   style="padding: 12px 24px; background: white; color: #667eea; border: none; border-radius: 8px; cursor: pointer; font-weight: bold;">
//             Continue to Access Page
//           </button>
//         </div>
//       </div>
//     `;
//   }

//   // Stop execution - don't mount Vue
//   throw new Error("Vue mount prevented - user lacks permissions");
// }

// Step 3: Mount Vue app (only reaches here if user has access)
// console.log("✅ Mounting Vue app...");

// Create and mount Vue app
// const app = createApp(App);
// app.use(router);
// registerPlugins(app);

// // Hide pre-load screen once Vue is mounted
// // app.mixin({
// //   mounted() {
// //     const preLoad = document.getElementById("pre-load");
// //     if (preLoad) {
// //       preLoad.style.display = "none";
// //     }
// //   },
// // });

// app.mount("#app");

// console.log("🎉 Vue app mounted successfully");
